import { render, staticRenderFns } from "./RequestQuoteF2BBVA.vue?vue&type=template&id=65a4b96a"
import script from "./RequestQuoteF2BBVA.vue?vue&type=script&lang=js"
export * from "./RequestQuoteF2BBVA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports